import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import { capitaliseFirstLetter } from '../../utils/capitalise-first-letter'
import { Primary } from '@cinch-labs/design-system'

interface StoreCtaButtonProps {
  trackEventTitle: string
  slug: string
}

export const StoreCtaButton = ({
  slug,
  trackEventTitle,
}: StoreCtaButtonProps) => {
  const StoreName = `Search all cars at ${capitaliseFirstLetter(slug)}`
  const { trackEvent } = useAnalytics()

  const storeBySlugPath = `/used-cars?store=${slug}`

  const handleClick = () => {
    trackEvent({
      eventName: trackEventTitle,
      type: TrackingEventTypes.ADOBE,
      data: {
        action: 'select',
        event: {
          name: EventNames.click,
          type: capitaliseFirstLetter(slug),
          category: trackEventTitle,
          label: 'search all cars',
        },
      },
    })
    window.open(storeBySlugPath, '_blank')
  }

  return (
    <Primary type="submit" data-testid="store-button" onClick={handleClick}>
      {StoreName}
    </Primary>
  )
}
